import {
  Avatar,
  XIcon,
  EllipsisIcon,
  Flex,
  MessengerIcon,
  ForwardIcon,
} from '@buffer-mono/popcorn'

import { EmptyMediaPlaceholder } from '../../../Common/styles'
import { VideoPlayer as VideoPlayerCommon } from '../../../Common/VideoPlayer'
import type { FacebookContent, ProfilePreview } from '../../../types'

import styles from './Story.module.css'

import type { JSX } from 'react'

export function Story({
  content,
  profile,
}: {
  content: FacebookContent
  profile: ProfilePreview
}): JSX.Element {
  const { avatar, username } = profile
  const { images, video } = content

  return (
    <div data-testid="story" className={styles.wrapper}>
      <div className={styles.header}>
        <div className={styles.info}>
          <Avatar
            data-testid="avatar"
            src={avatar}
            alt={username}
            size="small"
            fallback="image"
          />
          <div className={styles.username} translate="no">
            {profile.username}
          </div>
          <div>21h</div>
          <div className={styles.dots}>
            <EllipsisIcon />
          </div>
          <div className={styles.close}>
            <XIcon />
          </div>
        </div>
      </div>
      <div className={styles.content}>
        {images && images?.length > 0 && (
          <div
            className={styles.image}
            style={{ backgroundImage: `url(${images[0].url})` }}
          ></div>
        )}
        {video && <VideoPlayerCommon video={video} />}
        {!images?.length && !video && (
          <Flex className={styles.emptyWrapper}>
            <EmptyMediaPlaceholder
              service="facebook"
              className={styles.empty}
            />
          </Flex>
        )}
      </div>
      <div className={styles.footer}>
        <span className={styles.share}>
          <ForwardIcon />
        </span>
        {/* <div className={styles.like}>Share</div> */}
        <div className={styles.message}>
          <MessengerIcon />
          <span>Send message...</span>
        </div>
      </div>
    </div>
  )
}
